import React from 'react';
import { Outlet } from "react-router-dom";
import Contact from './ContactUs';
import Header from "./Header";

const Layout = ({ data, language}) => {
  return (
    <>
      <Header
        title={language ? data.English.Title : data.Mongolian.Title}
        data={language ? {... data.English.Header, ... data.English.Contact} :{... data.Mongolian.Header, ... data.Mongolian.Contact}}
      />
      <Outlet />
      <Contact
        data={language ? data.English.Contact : data.Mongolian.Contact}
      />
    </>
  )
};

export default Layout;
